import OutlookFolders from "./OutlookFolders";
import { setCurrentMail } from "../../../Slices/notification";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useExtractclientmail } from "./fetchClientMail";
export const MultiMailTab = () => {
  const dispatch = useDispatch();
  const Emails = useSelector((state) => state?.loginUserInfo?.loginUserDetails?.emailSettings);
  const mails = Emails
    ?.filter(item => item.status === true || item.status === "true")
    ?.map(item => item.email) || [];
  const sharedEmails = useSelector((state) => state?.loginUserInfo?.loginUserDetails?.sharedemailSettings);
  const sharedemails = useSelector((state) => state?.sharedEmail?.sharedemails);
  const emailMap = sharedemails?.reduce((acc, item) => {
    acc[item._id] = item.email;
    return acc;
  }, {}) || {};

  const sharedMails = sharedEmails
    ?.filter(item => item.status === true || item.status === "true")
    ?.map(item => emailMap[item.email]) // replace ID with actual email
    ?.filter(Boolean); // remove any undefined in case of unmatched IDs
  const data = useExtractclientmail();
  const allMails = Array.from(
    new Set([...mails, ...sharedMails,...data].map(email => email))
  );

  useEffect(() => {
    if (allMails?.length) {
      dispatch(setCurrentMail(allMails[0]));
    }
  }, [dispatch, allMails]);

  return <OutlookFolders EmailsLists={allMails} mode={true} />;
};
